import * as React from 'react';
import { createElement } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, getResources } from 'react-admin';
import { withRouter } from 'react-router-dom';
import DashboardOutlined from '@material-ui/icons/DashboardOutlined';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';

export const Menu = ({ onMenuClick, logout }) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);

  return (
    <nav className="fs-sidebar-menu">
      <div className="fs-sidebar-caption">УПРАВЛЕНИЕ</div>
      <MenuItemLink
        to="/"
        primaryText="Главная"
        leftIcon={<DashboardOutlined />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {resources.map((resource) => (
        <MenuItemLink
          key={resource.name}
          to={`/${resource.name}`}
          primaryText={(resource.options && resource.options.label) || resource.name}
          leftIcon={createElement(resource.icon)}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      ))}
      <MenuItemLink
        to="/settings"
        primaryText="Настройки"
        leftIcon={<SettingsOutlined />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {isXSmall && <div className="fs-sidebar-logout">{logout}</div>}
    </nav>
  );
};

export default withRouter(Menu);
